import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import React from 'react';
import LinkButton from '~/components/LinkButton';
import RegistrationDetailsList from '~/components/RegistrationDetailsList';
import { ROUTES } from '~/constants/ROUTES';
import { IndexPageQueryResult } from '~/generated/apollo';
import { UnityRegStateType } from '~/generated/graphql';
import getIcon from '~/helpers/getIcon';
import getMetadataForProgram from '~/helpers/getMetadataForProgram';
import { ProgramName } from '~/types';
import { StyledGridItemProductLogo, StyledGridItemRegistrationActions, StyledGridItemRegistrationDetails, StyledImg, StyledPaper } from './styles';
const IconArrowRight = getIcon('general.arrow.right');
const IconComplete = getIcon('general.check');
const IconDevice = getIcon('general.device');
const IconRoom = getIcon('general.roomCode');
export interface Props {
  registration: NonNullable<IndexPageQueryResult['data']>['myRegistrations'][0];
}
const RegistrationCard: React.FC<Props> = ({
  registration
}: Props): React.ReactElement<Props> => {
  const registrationId = registration.registration.id;
  const registrationState = registration.state;
  const programName = registration.program?.program_name as ProgramName;
  const programMetadata = getMetadataForProgram(programName);
  return <StyledPaper variant="outlined" data-sentry-element="StyledPaper" data-sentry-component="RegistrationCard" data-sentry-source-file="index.tsx">
      <Grid container data-sentry-element="Grid" data-sentry-source-file="index.tsx">
        <StyledGridItemProductLogo alignItems="center" item justifyContent="center" data-sentry-element="StyledGridItemProductLogo" data-sentry-source-file="index.tsx">
          <StyledImg alt={programMetadata.name} src={programMetadata.src} data-sentry-element="StyledImg" data-sentry-source-file="index.tsx" />
        </StyledGridItemProductLogo>
        <StyledGridItemRegistrationDetails item data-sentry-element="StyledGridItemRegistrationDetails" data-sentry-source-file="index.tsx">
          <Typography component="h2" gutterBottom variant="subtitle1" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
            <strong>{programMetadata.name}</strong>
          </Typography>

          <RegistrationDetailsList registration={registration} data-sentry-element="RegistrationDetailsList" data-sentry-source-file="index.tsx" />
        </StyledGridItemRegistrationDetails>

        <StyledGridItemRegistrationActions alignItems="center" display="flex" item justifyContent="center" data-sentry-element="StyledGridItemRegistrationActions" data-sentry-source-file="index.tsx">
          <Grid container flexDirection="column" gap={1} data-sentry-element="Grid" data-sentry-source-file="index.tsx">
            {registrationState === UnityRegStateType.Preparing && <Grid item xs={12}>
                <LinkButton color="success" endIcon={<IconArrowRight />} fullWidth href={{
              pathname: ROUTES.REGISTRATION({
                registrationId
              }),
              query: {
                runDeviceCheck: true
              }
            }} startIcon={<IconDevice />} variant="contained">
                  Run Device Check
                </LinkButton>
              </Grid>}

            {registrationState === UnityRegStateType.Testing && <Grid item xs={12}>
                <LinkButton color="success" endIcon={<IconArrowRight />} fullWidth href={{
              pathname: ROUTES.REGISTRATION({
                registrationId
              }),
              query: {
                enterRoomCode: true
              }
            }} startIcon={<IconRoom />} variant="contained">
                  Enter Room Code
                </LinkButton>
              </Grid>}

            {registrationState === UnityRegStateType.Completed && <Grid item xs={12}>
                <Button color="success" disabled fullWidth startIcon={<IconComplete />} variant="contained">
                  Completed
                </Button>
              </Grid>}

            <Grid item xs={12} data-sentry-element="Grid" data-sentry-source-file="index.tsx">
              <LinkButton color="primary" endIcon={<IconArrowRight />} fullWidth href={{
              pathname: ROUTES.REGISTRATION({
                registrationId
              })
            }} variant="outlined" data-sentry-element="LinkButton" data-sentry-source-file="index.tsx">
                Registration Details
              </LinkButton>
            </Grid>
          </Grid>
        </StyledGridItemRegistrationActions>
      </Grid>
    </StyledPaper>;
};
export default RegistrationCard;